
import * as tripApis from "../apis/trip_apis";

//action constants
export const DASHBOARD_CHANGE = "dashboardChange";
const DASHBOARD_DATA_LOADING = "dashboardDataLoading";
const DASHBOARD_DATA_LOADED = "dashboardDataLoaded";
export const INIT_DASHBORD = "initDashboard";

const initState = () => ({
    trips: [],
    filterTrips: "",
    loading: false,
    error: "",
    info: "",
})

const mutations = {
    [DASHBOARD_CHANGE] (state, payload) {
        Object.assign(state, {[payload.name]:payload.value});
    },
    [DASHBOARD_DATA_LOADING] (state) {
        Object.assign({state, loading: true, info: "", error: ""});
    },
    [DASHBOARD_DATA_LOADED] (state, payload) {
        Object.assign(state, {loading: false, info: payload.info, error: payload.error, trips: payload.trips});
    }
};

const actions = {
    [DASHBOARD_CHANGE] ({commit}, payload) {
        commit(DASHBOARD_CHANGE, payload);
    },
    [INIT_DASHBORD] ({commit, rootState}) {
        commit(DASHBOARD_DATA_LOADING);

        tripApis.loadDashbordData(rootState.globalStore.user.email)
            .then((results) => {
                commit(DASHBOARD_DATA_LOADED, {info: "", error: "", trips: results});
                },
                (results) => {
                let error = !results.error? "Failed to load dashboard data. Try again later.": results.error;
                commit(DASHBOARD_DATA_LOADED, {info: "", "error": error});
                })
    },
}

const dashboardStore = {
    state: initState(),
    mutations: mutations,
    actions: actions,
}

export default dashboardStore
